import React from "react";
import sitedata from "../sitedetails.json";
// import BrandVideo from "../assets/videos/polygon-loading.mp4";
import { Link } from "react-router-dom";
const Hero = () => {
  return (
    <div className="w-full">
      {/* max-w-[1512px] */}
      <div className=" font-outfit bg-black bg-cover bg-no-repeat bg-brand-image text-white h-[650px] items-center max-h-[650px]">
        <div className="items-center justify-center h-full flex ">
          <div className="text-center">
            <h4 className="text-2xl lg:text-4xl my-8 font-semibold sm:px-[200px] md:px-[300] lg:px-[400px]">{sitedata.brand_quote}</h4>
            <h2 className="text-lg lg:text-2xl font-semibold my-4 sm:px-[200px] md:px-[300] lg:px-[400px] tracking-widest ">
              {sitedata.brand_sub_description}
            </h2>
            <p className="text-base lg:text-xl my-2  lg:px-[500px] ">
              Get your Access to Premium Content Now
            </p>
            <Link to="/signup">
            <button className="transition hover:scale-110 hover:-translate-y-1 ease-out duration-300  my-8 py-2 px-6 bg-brand_yellow text-black font-semibold">
              Get Started Now
            </button>
            </Link>
            
          </div>
        </div>
      </div>

      <div className="bg-brand_deep_blue h-full w-full text-center flex justify-center px-5 text-white">
        {/* <h1>Promotional Video</h1> */}
        {/* <video className="w-[60%] rounded-md"
          src={BrandVideo}
          autoPlay={true}
          controls
          disablePictureInPicture
          disableRemotePlayback
          controlsList="nodownload nofullscreen noremoteplayback"
        ></video>
        */}
      </div>
    </div>
  );
};

export default Hero;
